// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__nnuPI","inner":"Footer_inner__3qE8B","nextIcon":"Footer_nextIcon__2EN-w","innerLeft":"Footer_innerLeft__2FZ70"};